import { AbacoVuexModule, State, MenuItem } from "@abaco/web-common/src/app";
import { MenuItemWithOrd } from ".";

export default class MenuVuexModule extends AbacoVuexModule {
    @State() menu!: MenuItemWithOrd[];
    @State() curMenuItem!: MenuItem | null;
    @State({ default: true }) loading!: boolean;
    @State() homePage!: MenuItem | null;
}
